// extracted by mini-css-extract-plugin
export default {"cont":"UserImage_cont__3JTN4","parent":"UserImage_parent__VvdtE","user-image":"UserImage_user-image__J-O7U","child":"UserImage_child__Kc3XW"};